import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import * as S from '../scss/theme';
import fnc from "../mymod/commFunction";
import './MyRoom_stu.scss';

import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { FiBarChart2, FiSettings } from 'react-icons/fi';
import { FaChalkboardTeacher, FaUserGraduate, FaChartBar, FaTasks,
    FaBook, FaMedal, FaBullhorn, FaLaptopCode, FaUserPlus, FaUsers, 
    FaUserCog, FaHome, FaDigitalTachograph, FaFileAlt, FaClipboardList,
    FaEdit, FaSave, FaUserEdit, FaClipboardCheck, FaPoll } from 'react-icons/fa';  


import { useNavigate } from "react-router-dom";


const MyRoom_stu = () => {
    const userInfo = useSelector((state) => state.reduxStore.userInfo);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [activeIndex, setActiveIndex] = useState(-1);
    const [activeMenuItem, setActiveMenuItem] = useState(null); // 초기값을 null로 설정



    
function handleAssessment_allSt() {
 setActiveMenuItem('학원장진단');

}

function handleAssessment_allSt2() {
 setActiveMenuItem('학원장진단2');

}

function onCreateLms(type) {
    if (type === '교사용') {
        setActiveMenuItem('LMS생성_교사용');    
        navigate('/lmsTec');
    } else if (type === '학생용') {
        setActiveMenuItem('LMS생성_학생용');
        navigate('/lms');
    }
}

    //=============================================
    return (
        <>
            <div className="MyRoom_stu">
                <Menu className="custom-menu">
                    <SubMenu 
                        label="LMS"
                        icon={<FaLaptopCode />}
                        defaultOpen={true}
                    >
                        <MenuItem 
                            icon={<FaUserGraduate />}
                            onClick={() => onCreateLms('학생용')}
                            active={activeMenuItem === 'LMS생성_학생용'}
                        >
                            LMS
                        </MenuItem>
                        <MenuItem
                            icon={<FiBarChart2 />}
                            onClick={() => { navigate('/LmsReport'); setActiveMenuItem('학습리포트'); }}
                            active={activeMenuItem === '학습리포트'}
                        >
                            학습 리포트
                        </MenuItem>
                    </SubMenu>

                    <SubMenu 
                        label="문제은행" 
                        icon={<FaBook />}
                        defaultOpen={true}
                    >
                        <MenuItem 
                            icon={<FaDigitalTachograph />}
                            onClick={() => {navigate('/digital'); setActiveMenuItem('디지털1.0'); }}
                            active={activeMenuItem === '디지털1.0'}
                        >
                        디지털1.0
                        </MenuItem>
                        <MenuItem 
                            icon={<FaDigitalTachograph />}
                            onClick={() => {navigate('/book'); setActiveMenuItem('디지털2.0'); }}
                            active={activeMenuItem === '디지털2.0'}
                        >
                            디지털2.0
                        </MenuItem>
                        <MenuItem 
                            icon={<FaClipboardCheck />}
                            onClick={() => {navigate('/exam'); setActiveMenuItem('진단평가'); }}
                            active={activeMenuItem === '진단평가'}
                        >
                        진단평가
                        </MenuItem>

                    </SubMenu>

                    <SubMenu 
                        label="수강신청" 
                        icon={<FaClipboardList />}
                        defaultOpen={true}
                    >
                        <MenuItem 
                            icon={<FaUserPlus />}
                            onClick={() => {navigate('/courseReg'); setActiveMenuItem('수강신청'); }}
                            active={activeMenuItem === '수강신청'}
                        >
                            수강신청
                        </MenuItem>

                    </SubMenu>

                    <SubMenu 
                        label="내 정보 수정" 
                        icon={<FaUserEdit />}
                        defaultOpen={true}
                        className="empty-submenu"
                        onClick={() => {navigate('/updateapp'); setActiveMenuItem('내 정보수정'); }}
                        active={activeMenuItem === '내 정보수정'}
                    ></SubMenu>

                </Menu>

            </div>

        </>
    );
};

export default MyRoom_stu;
